// Angular Import
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// project import
import { AdminComponent } from './theme/layout/admin/admin.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { AuthGuardChild } from './theme/shared/_helpers/auth.guard';
import { Role } from './theme/shared/_helpers/role';
import { AuthSetPassword } from './demo/pages/authentication/auth-set-password/auth-set-password';
const routes: Routes = [
  {
    path: '',
    component: GuestComponent,
    children: [
      { path: '', redirectTo: '', pathMatch: 'full' },
      {
        path: '',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signin-v2/auth-signin-v2.component').then((c) => c.AuthSigninV2Component)
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signin-v2/auth-signin-v2.component').then((c) => c.AuthSigninV2Component)
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-signup-v2/auth-signup-v2.component').then((c) => c.AuthSignupV2Component)
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-reset-password-v2/auth-reset-password-v2.component').then(
            (c) => c.AuthResetPasswordV2Component
          )
      },
      { path: 'set-password', component: AuthSetPassword },
      {
        path: 'maintenance',
        loadChildren: () => import('./demo/pages/maintenance/maintenance.module').then((m) => m.MaintenanceModule)
      },
      {
        path: 'auth',
        canActivateChild: [AuthGuardChild],
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then((m) => m.AuthenticationModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./demo/pages/maintenance/un-authorized-page/un-authorized-page.component').then((c) => c.UnAuthorizedPageComponent)
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    canActivateChild: [AuthGuardChild],
    children: [
      {
        path: 'com_md',
        loadChildren: () => import('./project_files/common_module/common_module-module').then((m) => m.CommonModuleModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
      {
        path: 'fabric',
        loadChildren: () => import('./project_files/fabric/fabric-module').then((m) => m.FabricModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
      {
        path: 'pl',
        loadChildren: () => import('./project_files/planner/planner-module').then((m) => m.PlannerModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
      {
        path: 'mnt',
        loadChildren: () => import('./project_files/maintenance/maintenance-module').then((m) => m.MaintenanceModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
      {
        path: 'sample_form',
        loadChildren: () => import('./project_files/sample_form/sample_form.module').then((m) => m.SampleFormModule),
        data: { roles: [Role.admin, Role.Admin, Role.superadmin, Role.user, Role.User] }
      },
     
      {
        path: 'masters',
        loadChildren: () => import('./project_files/fabric/masters/masters-module').then((m) => m.MastersModule),
        data: { roles: [Role.admin, Role.Admin, Role.user, Role.User] }
      },
      {
        path: 'subscription',
        loadChildren: () => import('./project_files/subscription_module/subscription-module-routing-module').then((m) => m.SubscriptionModuleRoutingModule),
        data: { roles: [Role.superadmin, Role.admin, Role.Admin] }
      }
    ]
  },

  {
    path: '**',
    loadComponent: () => import('./demo/pages/maintenance/error404-page/error404-page.component').then((c) => c.Error404PageComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
